import React from "react";
import { Link } from "react-router-dom";
import "../assets/style.css";
import "../assets/vendor/animate.css/animate.min.css";
import "../assets/vendor/bootstrap/css/bootstrap.min.css";
import "../assets/vendor/bootstrap-icons/bootstrap-icons.css";
import "../assets/vendor/boxicons/css/boxicons.min.css";
import "../assets/vendor/swiper/swiper-bundle.min.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons';
import footerlogo from '../assets/img/footerlogo.jpeg'

export const Footer = () => {
    return (
        <footer id="footer" className="footer">
            <div className="footer-top">
                <div className="container">
                    <div className="row gy-4">

                        <div className="col-lg-4 col-md-6 footer-info">
                            <h3>OASIS Educational Institute</h3>
                            <p className="mt-3">
                                Dedicated to providing quality education and fostering academic excellence.
                            </p>
                            <div className="contact-details mt-4">
                                <div>
                                    <i className="bi bi-geo-alt"></i> Main Campus: Gogji Bagh, Srinagar
                                </div>
                                <div>
                                    <i className="bi bi-geo-alt"></i> Other Campus: Gulshan Nagar, Srinagar
                                </div>
                                <div>
                                    <i className="bi bi-clock"></i> Week Days: 09:30 AM - 04:00 PM
                                </div>
                                <div>
                                    <i className="bi bi-clock"></i> Sunday: Closed
                                </div>
                                <div>
                                    <div className="helpline-numbers mt-8">
                                        <div><i className="bi bi-telephone"></i> Helpline: <a href="tel:91-9469844596">91-9469844596 (24X7)</a></div>
                                        <div><i className="bi bi-telephone"></i> IT ADMIN: <a href="tel:+91-9086096005">+91-9086096005</a> (Website and IT related)</div>
                                        <div><i className="bi bi-telephone"></i> Telephone: <a href="tel:0194-2310701">0194-2310701</a></div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="col-lg-2 col-md-6 footer-links">
                            <h4>Quick Links</h4>
                            <ul>
                                <li><Link to="/"><i className="bx bx-chevron-right"></i> Home</Link></li>
                                <li><Link to="/about"><i className="bx bx-chevron-right"></i> About Us</Link></li>
                                <li><Link to=""><i className="bx bx-chevron-right"></i> Terms of Service</Link></li>
                                <li><Link to=""><i className="bx bx-chevron-right"></i> Privacy Policy</Link></li>
                            </ul>
                        </div>


                        <div className="col-lg-3 col-md-6 footer-links">
                            <h4>Our Services</h4>
                            <ul>
                                <li><Link to="/admission"><i className="bx bx-chevron-right"></i> Admission</Link></li>
                                <li><Link to="/careers"><i className="bx bx-chevron-right"></i> Careers</Link></li>
                                <li><Link to=""><i className="bx bx-chevron-right"></i> Achievements</Link></li>
                                <li><Link to=""><i className="bx bx-chevron-right"></i> Library</Link></li>
                                <li><Link to=""><i className="bx bx-chevron-right"></i> Scholarships</Link></li>
                                <li><Link to=""><i className="bx bx-chevron-right"></i> JKBOSE</Link></li>
                                <li><Link to="/model-papers"><i className="bx bx-chevron-right"></i> Model Papers</Link></li>
                            </ul>
                        </div>


                        <div className="col-lg-3 col-md-6 footer-links">
                            <h4>More Links</h4>
                            <ul>
                                <li><Link to=""><i className="bx bx-chevron-right"></i> Results</Link></li>
                                <li><Link to=""><i className="bx bx-chevron-right"></i> Application Forms</Link></li>
                                <li><Link to=""><i className="bx bx-chevron-right"></i> Assignments</Link></li>
                                <li><Link to=""><i className="bx bx-chevron-right"></i> RTI Act</Link></li>
                                <li><Link to="/syllabus"><i className="bx bx-chevron-right"></i> Syllabus</Link></li>
                                <li><Link to=""><i className="bx bx-chevron-right"></i> Online Classes</Link></li>
                                <li><Link to=""><i className="bx bx-chevron-right"></i> Video Lectures</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>


            <div className="footer-bottom py-4">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 text-center text-md-start ">
                            <div className="copyright">
                                &copy; {new Date().getFullYear()} <strong>OASIS Educational Institute</strong>. All Rights Reserved.


                            </div>
                            <div className="credits mt-2">
                                Developed & Designed By: <a href="https://www.linkedin.com/in/ayan-rafiqi/" target="_blank" rel="noopener noreferrer">Ayan Rafiqi</a>
                            </div>
                            <div className="credits mt-2 mb-2">
                                Managed by: <a href="/">OASIS IT DEPARTMENT</a>
                            </div>
                            <div className="social-links mb-2 pt-1">
                                <a href="https://www.facebook.com/share/qKUCJp7W477txCNU/?mibextid=LQQJ4d" target="_blank" rel="noopener noreferrer" className="facebook">
                                    <i className="bx bxl-facebook"></i>
                                </a>
                                <a href="https://www.instagram.com/oasis.sgr?igsh=dWI0c210b2VrYTgz" target="_blank" rel="noopener noreferrer" className="instagram">
                                    <i className="bx bxl-instagram"></i>
                                </a>
                                <a href="https://www.linkedin.com/company/oasis-educational-institute/" target="_blank" rel="noopener noreferrer" className="linkedin">
                                    <i className="bx bxl-linkedin"></i>
                                </a>
                                <a href="https://www.youtube.com/@oasishighersecondaryeducat9744" rel="noopener noreferrer" target="_blank" className="youtube">
                                    <i className="bi bi-youtube"></i>
                                </a>
                                <a href="https://x.com/oeisgr" target="_blank" rel="noopener noreferrer" className="twitter">
                                    <FontAwesomeIcon icon={faXTwitter} />
                                </a>
                            </div>
                        </div>
                        <div className="col-md-6 d-flex flex-column justify-content-end align-items-end text-end text-md-end sm: justify-content-center align-items-center text-center pb-2">
                            <div className="footer-logo mb-3">
                                <img
                                    className=" w-auto
                            h-12 sm:h-20 
                            md:h-24 md:w-32
                            lg:h-24 lg:w-32
                            xl:h-46 xl:w-100 
                            max-h-[120px] min-h-[40px] 
                            object-contain 
                            object-center 
                            transition-all duration-300"
                                    src={footerlogo}
                                    alt="no png found"
                                />
                            </div>
                            {/* Social Links Below Logo */}

                        </div>
                    </div>
                </div>
            </div>
        </footer>

    );
};